/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getAssessmentLevelList = (payload, callback) =>
  req.list(
    c.GET_ASSESSMENT_LEVEL_LIST,
    'api/v1/rpt/administrator/land/settings/land_assessment_levels',
    payload,
    callback
  );

export const getSingleAssessmentLevel = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_ASSESSMENT_LEVEL,
    `api/v1/rpt/administrator/land/settings/land_assessment_levels/${id}`,
    payload,
    callback
  );

export const createAssessmentLevel = (payload, callback) =>
  req.create(
    c.CREATE_ASSESSMENT_LEVEL,
    'api/v1/rpt/administrator/land/settings/land_assessment_levels',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateAssessmentLevel = (id, payload, callback) =>
  req.update(
    c.UPDATE_ASSESSMENT_LEVEL,
    `api/v1/rpt/administrator/land/settings/land_assessment_levels/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeAssessmentLevel = (id, payload, callback) =>
  req.remove(
    c.REMOVE_ASSESSMENT_LEVEL,
    `api/v1/rpt/administrator/land/settings/land_assessment_levels/${id}`,
    payload,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

  export const getActualUseList = (payload, callback) =>
  req.list(
    c.GET_ACTUAL_USE_LIST,
    'api/v1/rpt/administrator/settings/actual_uses',
    payload,
    callback
  );

  export const getOrdinanceRevisionList = (payload, callback) =>
  req.list(
    c.GET_ORDINANCE_REVISION,
    'api/v1/rpt/administrator/settings/ordinance_revisions',
    payload,
    callback
  );

  export const getLandClassificationList = (payload, callback) =>
  req.list(
    c.GET_LAND_CLASSIFICATION_LIST,
    'api/v1/rpt/administrator/land/settings/land_classifications?status=1',
    payload,
    callback
  );

  export const clearItem = (constant, value) => req.setItem(constant, value);